interface Props {
  style?: React.CSSProperties
  className?: string
  fill?: string
}

export function WingCircle({ style, className = '', fill = '' }: Props) {
  return (
    <i className={`icon ${className}`} style={style}>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="16" fill="url(#paint0_linear_2001_2018)"/>
        <g clipPath="url(#clip0_2001_2018)">
          <path d="M12.9996 20.1701L9.52965 16.7001C9.13965 16.3101 8.50965 16.3101 8.11965 16.7001C7.72965 17.0901 7.72965 17.7201 8.11965 18.1101L12.2996 22.2901C12.6896 22.6801 13.3196 22.6801 13.7096 22.2901L24.2896 11.7101C24.6796 11.3201 24.6796 10.6901 24.2896 10.3001C23.8997 9.91007 23.2696 9.91007 22.8796 10.3001L12.9996 20.1701Z" fill="white"/>
        </g>
        <defs>
          <linearGradient id="paint0_linear_2001_2018" x1="-37.4545" y1="32" x2="32.3292" y2="30.7352" gradientUnits="userSpaceOnUse">
            <stop stopColor="#2E6CF2"/>
            <stop offset="1" stopColor="#53CA7C"/>
          </linearGradient>
          <clipPath id="clip0_2001_2018">
            <rect width="24" height="24" fill="white" transform="translate(4 4)"/>
          </clipPath>
        </defs>
      </svg>
    </i>
  )
}
